module.exports = __webpack_public_path__ + "media/components/src/assets/images/icons/icon-gift-87a699a43de7b29968d6f85866b748a4.png";